import { api } from '../apiConfig';

export const mentorshipService = {
  /**
   * Get available mentorship time slots
   * @returns {Promise<Array>} Array of available slots
   */
  async getAvailableSlots() {
    try {
      const response = await api.get('/mentorship/slots');
      return response.data.slots || [];
    } catch (error) {
      console.error('Error fetching available slots:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch available slots');
    }
  },

  /**
   * Create a mentorship booking and Stripe checkout session
   * @param {Object} bookingData - Booking information
   * @param {string} bookingData.slotId - Selected slot ID
   * @param {string} bookingData.datetime - Selected datetime
   * @param {string} bookingData.portfolioLink - Portfolio URL
   * @param {string} bookingData.topGoal - User's career goal
   * @param {Object} bookingData.customerInfo - Customer information
   * @returns {Promise<Object>} Booking response with checkout URL
   */
  async createBooking(bookingData) {
    try {
      const response = await api.post('/mentorship/booking', bookingData);
      return response.data;
    } catch (error) {
      console.error('Error creating booking:', error);
      throw new Error(error.response?.data?.message || 'Failed to create booking');
    }
  },

  /**
   * Get booking details by ID
   * @param {string} bookingId - Booking ID
   * @returns {Promise<Object>} Booking details
   */
  async getBooking(bookingId) {
    try {
      const response = await api.get(`/mentorship/booking/${bookingId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching booking:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch booking');
    }
  },

  /**
   * Reschedule a booking
   * @param {string} bookingId - Booking ID
   * @param {string} newSlotId - New slot ID
   * @param {string} newDatetime - New datetime
   * @returns {Promise<Object>} Updated booking
   */
  async rescheduleBooking(bookingId, newSlotId, newDatetime) {
    try {
      const response = await api.put(`/mentorship/booking/${bookingId}/reschedule`, {
        slotId: newSlotId,
        datetime: newDatetime
      });
      return response.data;
    } catch (error) {
      console.error('Error rescheduling booking:', error);
      throw new Error(error.response?.data?.message || 'Failed to reschedule booking');
    }
  },

  /**
   * Get user's mentorship bookings
   * @returns {Promise<Array>} Array of user's bookings
   */
  async getUserBookings() {
    try {
      const response = await api.get('/mentorship/bookings');
      return response.data.bookings || [];
    } catch (error) {
      console.error('Error fetching user bookings:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch bookings');
    }
  }
};

export default mentorshipService; 